import(/* webpackMode: "eager" */ "/app/src/app/terms-and-conditions/page.tsx")